package com.essntl.features.currency.domain.model

data class CurrencyModel(
    val symbol: String,
    val code: String,
    val name: String,
)
